import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createProjectModule, fetchProjectModules, setProjectModuleActive, updateProjectModule } from '../api/project.api';

export const PROJECT_MODULE_KEYS = {
  list: (projectId: string) => ['project-modules', projectId] as const,
};

export function useProjectModules(projectId: string) {
  return useQuery({
    queryKey: PROJECT_MODULE_KEYS.list(projectId),
    queryFn: () => fetchProjectModules(projectId),
    enabled: Boolean(projectId),
  });
}

export function useCreateProjectModule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, data }: { projectId: string; data: { name: string; description?: string | null } }) =>
      createProjectModule(projectId, data),
    onSuccess: (_result, { projectId }) =>
      queryClient.invalidateQueries({ queryKey: PROJECT_MODULE_KEYS.list(projectId) }),
  });
}

export function useUpdateProjectModule() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      projectId,
      moduleId,
      data,
    }: {
      projectId: string;
      moduleId: string;
      data: { name?: string; description?: string | null };
    }) => updateProjectModule(projectId, moduleId, data),
    onSuccess: (_result, { projectId }) =>
      queryClient.invalidateQueries({ queryKey: PROJECT_MODULE_KEYS.list(projectId) }),
  });
}

export function useSetProjectModuleActive() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ projectId, moduleId, active }: { projectId: string; moduleId: string; active: boolean }) =>
      setProjectModuleActive(projectId, moduleId, active),
    onSuccess: (_result, { projectId }) =>
      queryClient.invalidateQueries({ queryKey: PROJECT_MODULE_KEYS.list(projectId) }),
  });
}
